import React from 'react';
import _ from 'lodash';

import {
  selectGeneralTexts,
  selectLoginPageTexts,
  selectTexts,
  selectActionsPanelTexts,
  selectHeaderTexts,
  selectRoomContentTexts,
  selectPopUpsTexts,
  selectHints,
  selectRoles,
  selectTermsFooter,
  selectConnectionsControll,
} from 'routes/client/redux/settings/selectors';
import { useAppSelector } from './redux';

type TranslationSource =
  | 'general'
  | 'login'
  | 'actionsPanel'
  | 'header'
  | 'room'
  | 'popUps'
  | 'termsFooter'
  | 'hints'
  | 'roles'
  | 'connectionsControll';

export type translateT = (path: string, options?: Record<string, string>) => string;

/**
 * Usage:
 * const { translate } = useTranslation('logIn'); // will use store.settings.texts.{lang}.logIn
 * // assuming: store.settings.texts.{lang}.logIn.hello = 'hello ${name}';
 * const str = translate('hello', { name: 'Dear User' });
 * // -> str = 'hello Dear User
 *
 * If source is not provided translate function will use store.setting.texts.{lang} as base
 */
export const useTranslation = (source?: TranslationSource): { translate: translateT } => {
  const selectorsMap = {
    general: selectGeneralTexts,
    login: selectLoginPageTexts,
    actionsPanel: selectActionsPanelTexts,
    header: selectHeaderTexts,
    room: selectRoomContentTexts,
    popUps: selectPopUpsTexts,
    hints: selectHints,
    roles: selectRoles,
    termsFooter: selectTermsFooter,
    connectionsControll: selectConnectionsControll,
  };
  const texts = useAppSelector(source ? selectorsMap[source] : selectTexts);
  const translate = React.useCallback(
    (path: string, options?: Record<string, string>) => {
      let result = _.get(texts, path, path);
      if (options) {
        const compiled = _.template(result);
        result = compiled(options);
      }

      return result;
    },
    [texts],
  );

  return { translate };
};
